<template>
  <div class="h-24 bg-light-green text-white rounded-lg grid content-center px-4 mb-5">
    <span class="text-xl font-semibold">{{ title }}</span>
    <span class="text-base">{{ subtitle || "" }}</span>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      require: true,
    },
    subtitle: {
      type: String,
    },
  },
};
</script>

<style lang="scss" scoped></style>
